// removed by extract-text-webpack-plugin
module.exports = {"a-checkbox":"_3ETqh2nrfai89JXSqgK1N1"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/FormInput/CheckboxStyle.scss
// module id = 948
// module chunks = 0